/**
 * @author gyb(mocheer)
 * @since 2017.5.20
 * DMap
 */
let { Util, TileLayer } = L;
/**
 * DMap
 */
export default TileLayer.extend({
  getTileUrl: function (coords) {
    let z = this._getZoomForUrl(),
      { x, y } = coords,
      n = Math.pow(2, z),
      quad = '',
      lookup = "qrts"; // tl tr bl br
    x = x / n;
    y = y / n;
    if (y >= 0 && y < 1) {
      for (let i = 1; i <= z; i++) {
        // make sure we only look at fractional part
        x -= Math.floor(x);
        y -= Math.floor(y);
        quad += lookup.charAt((x >= 0.5 ? 1 : 0) + (y >= 0.5 ? 2 : 0));
        // now descend into that square
        x *= 2;
        y *= 2;
      }
    }
    return Util.template(this._url, { id: quad })
  }
})



// WEBPACK FOOTER //
// ./src/provider/DMap.js